import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../../assets/images/icon_error_messages.gif';

const MultiProvinces = ({ label, name, list, errors, touched }) => {
  return (
    <>
      <div className="main-content-form-headers" style={{ marginTop: 20 }}>
        <span className="select-placeholder">{label}*</span>
      </div>
      <div
        style={{ position: 'relative', width: '100%' }}
        className={`frg-select-container color-light input-container ${
          errors[name] && touched[name] ? 'error' : ''
        }`}
      >
        <div role="group" aria-labelledby="checkbox-group">
          {list.map(item => {
            return (
              <div key={item.name}>
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */}
                <label>
                  <Field
                    type="checkbox"
                    name={name}
                    value={item.id.toString()}
                  />
                  {` ${item.name}`}
                </label>
              </div>
            );
          })}
        </div>
        <div className="error_messages">
          <span className="frg-body-font-14px">{errors[name]}</span>
        </div>
        <div id="multiProvinces_error_icon" className="error_messages_icon">
          <img src={ErrorIcon} alt="error_icon" />
        </div>
      </div>
    </>
  );
};

MultiProvinces.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ).isRequired,
  errors: PropTypes.shape({
    multiProvinces: PropTypes.string
  }).isRequired,
  touched: PropTypes.shape({
    multiProvinces: PropTypes.oneOfType([PropTypes.bool, PropTypes.array])
  }).isRequired
};

export default MultiProvinces;
